import { useContext, useEffect } from 'react';
import { type QuickActionStatus, QuickActionStatusContext } from './QuickActionStatusContext';

/**
 * Publishes one domain's markers while mounted. `status` is an effect dependency, so memoize it.
 * Depends on the two actions rather than the context object, whose identity changes on every
 * publish: depending on the object republishes in a loop. Same reason `useConditionalBanner` does it.
 */
export function useQuickActionStatusRegistration(source: string, status: QuickActionStatus) {
  const { publish, clear } = useContext(QuickActionStatusContext) ?? {};

  useEffect(() => {
    if (!publish || !clear) {
      return;
    }
    publish(source, status);
    return () => clear(source);
  }, [publish, clear, source, status]);
}
